import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
  noPadding?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', title, action, noPadding = false }) => {
  return (
    <div className={`bg-white rounded-2xl shadow-card border border-neutral-200/60 overflow-hidden animate-fade-in ${className}`}>
      {(title || action) && (
        <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-neutral-200/60 flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-gradient-to-r from-neutral-50/80 to-white">
          {title && <h3 className="text-base sm:text-lg font-semibold text-neutral-800">{title}</h3>}
          {action && <div className="flex flex-wrap gap-2">{action}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'p-4 sm:p-6'}>{children}</div>
    </div>
  );
};
